import React, { useState } from 'react';
import EmailEventsAdminList from './components/EmailEventsAdminList';
import EmailEventsAdminAdd from './components/EmailEventsAdminAdd';
import { Box, Tabs, Tab } from '@mui/material';

const EmailEventsAdminPage: React.FC = () => {
  const [tab, setTab] = useState(0);

  const handleTabChange = (_: React.SyntheticEvent, newValue: number) => {
    setTab(newValue);
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Tabs value={tab} onChange={handleTabChange} aria-label="Email Events admin tabs">
        <Tab label="List Email Events" />
        <Tab label="Insert Email Event" />
      </Tabs>
      <Box sx={{ mt: 2 }}>
        {tab === 0 && <EmailEventsAdminList />}
        {tab === 1 && <EmailEventsAdminAdd />}
      </Box>
    </Box>
  );
};

export default EmailEventsAdminPage;
